import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContext, useUserState } from "../../../Contexts/UserContext";
import { ca, se } from "date-fns/locale";
import { Form, Modal, Spinner, Button } from "react-bootstrap";
import Select from "react-select";
import LoadrButton from "../../common/LoadingButton";
export default function BedAndBathroom() {
  const location = useLocation();
  const navigate = useNavigate();
  const formRef = useRef(null);
  const { user } = useUserState();
  const [isEdit, setIsEdit] = useState(false);
  const { leasePeriod, categoryId, categoryName, EditPackageId } =
    location.state || {};
  const [packageId, setPackageId] = useState(EditPackageId || null);
  const [formData, setFormData] = useState({ bedroom: "", bathroom: "" });
  const [allFurniture, setAllFurniture] = useState([]);
  const [selectedFurnitureIds, setSelectedFurnitureIds] = useState([]);
  const [allHousewareItems, setAllHousewareItems] = useState([]);
  const [selectedHousewareIds, setSelectedHousewareIds] = useState([]);
  const [packageFurList, setPackageFurList] = useState([]);
  const [buttonLoader, setButtonLoader] = useState(false);
  const bedOptions = Array.from({ length: 10 }, (_, i) => ({ beds: i + 1 }));
  const bathroomOptions = Array.from({ length: 10 }, (_, i) => ({
    bathrooms: i + 1,
  }));
  // Fetch all furniture for dropdown
  const fetchAllFurniture = async (categoryId, leasePeriod, packageId) => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    try {
      let res = await axios.get(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/package-furniture/non-assigned-furniture?category_id=${categoryId}&lease_period=${leasePeriod}&package_id=${
          packageId ? packageId : ""
        }`,
        { headers: headersFormData }
      );
      setAllFurniture(res.data?.data?.availableFurniture);
    } catch (err) {
      console.error("Error fetching all furniture:", err);
    }
  };
  const fetchAllHousewareItems = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    try {
      let res = await axios.get(
        `${import.meta.env.VITE_APP_BASE_URL}/api/furniture/houseware/get-list`,
        { headers: headersFormData }
      );
      // debugger
      setAllHousewareItems(res.data?.data);
    } catch (err) {
      console.error("Error fetching all furniture:", err);
    }
  };

  // Handlers
  const handleBedChange = (e) => {
    const selectedBeds = parseInt(e.target.value, 10);
    setFormData((prev) => ({ ...prev, bedroom: selectedBeds }));
  };

  const handleBathroomChange = (e) => {
    const selectedBathrooms = parseInt(e.target.value, 10);
    setFormData((prev) => ({ ...prev, bathroom: selectedBathrooms }));
  };

  const handleChange = (selectedOptions) => {
    const ids = selectedOptions.map((opt) => opt.value);
    setSelectedFurnitureIds(ids);
  };
  const handleHousewareChange = (selectedOptions) => {
    const ids = selectedOptions.map((opt) => opt.value);
    setSelectedHousewareIds(ids);
  };
  const options = allFurniture.map((f) => ({
    value: f.id,
    label: `${f.name} ($${f.price})`,
  }));
  const housewareOptions = allHousewareItems.map((f) => ({
    value: f.id,
    label: `${f.name} ($${f.price})`,
  }));
  // Save package (create or update)

  const handleSaveFurnitureSelection = async () => {
    if (!formData.bedroom) {
      return alert("Please select bedrooms first");
    }
    const payload = {
      lease_period: leasePeriod,
      furniture_category_id: categoryId,
      bedrooms: formData.bedroom,
      bathrooms: formData.bathroom,
    };

    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    setButtonLoader(true);
    try {
      let res;
      if (isEdit) {
        res = await axios.put(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/package/update-package/${packageId}`,
          payload,
          { headers: headersFormData }
        );
      } else {
        res = await axios.post(
          `${import.meta.env.VITE_APP_BASE_URL}/api/package/create-package`,
          payload,
          { headers: headersFormData }
        );
        setPackageId(res.data.data.id);
      }

      const packageIdToUse = packageId || res.data.data.id;

      // Insert Furniture
      if (selectedFurnitureIds?.length > 0) {
        await axios.post(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/package-furniture/insert-package-furniture`,
          {
            package_id: packageIdToUse,
            furniture: selectedFurnitureIds.map((id) => ({ furniture_id: id })),
          },
          { headers: headersFormData }
        );
      }

      // Insert Houseware (add this)
      if (selectedHousewareIds?.length > 0) {
        await axios.post(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/package-furniture/insert-package-furniture`,
          {
            package_id: packageIdToUse,
            furniture: selectedHousewareIds.map((id) => ({ furniture_id: id })),
          },
          { headers: headersFormData }
        );
      }

      fetchPackageFurnithure(packageIdToUse);
      fetchAllFurniture(categoryId, leasePeriod, packageIdToUse);

      setSelectedFurnitureIds([]);
      setSelectedHousewareIds([]);
      setButtonLoader(false);
    } catch (err) {
      console.error("Error saving package:", err);
      setButtonLoader(false);
    }
  };

  const handleNewAddFurniture = () => {
    if (formRef.current && !formRef.current.reportValidity()) return;
    navigate("/user_dash/furniture_company/add_new_furniture", {
      state: { categoryId, packageId, leasePeriod, categoryName },
    });
  };
  const handleNewAddHouseware = () => {
    if (formRef.current && !formRef.current.reportValidity()) return;
    navigate("/user_dash/furniture_company/add_new_houseware", {
      state: { categoryId, packageId, leasePeriod, categoryName },
    });
  };
  //get packge detail by package id
  const fetchPackage = async (id) => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      // setIsLoader(true);
      try {
        let res = await axios.get(
          `${import.meta.env.VITE_APP_BASE_URL}/api/package/get-package/${id}`,
          { headers: headersFormData }
        );
        const pkg = res.data.data;
        setFormData({ bedroom: pkg.bedrooms, bathroom: pkg.bathrooms });
        setSelectedFurnitureIds(
          pkg.package_furnitures.map((f) => f.furniture_id)
        );
        setIsEdit(true);
      } catch (err) {
        // setIsLoader(false);
        return console.log(err);
      }
    }
  };
  const fetchPackageFurnithure = async (id) => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      try {
        let res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/package-furniture/get-package-furniture-list/${id}`,
          { headers: headersFormData }
        );
        setPackageFurList([...res.data.data]);
      } catch (err) {
        return console.log(err);
      }
    }
  };
  useEffect(() => {
    fetchAllFurniture(categoryId, leasePeriod, packageId);
    fetchAllHousewareItems(categoryId, leasePeriod, packageId);
    if (packageId) {
      fetchPackage(parseInt(packageId));
      fetchPackageFurnithure(packageId);
    }
  }, [packageId, user?.token]);

  return (
    <div className="main-box">
      <div className="content-header">
        <h3>{EditPackageId ? "Edit" : "Add"} Package</h3>
      </div>
      <div className="row">
        <div className="col-12">
          <form
            ref={formRef}
            className="d-flex flex-column gap-3 editp_pet_field add_new_furnit_field"
          >
            {/* Category */}
            <Form.Group className="mb-3">
              <Form.Label>Selected Category</Form.Label>
              <Form.Control
                type="text"
                value={categoryName || "-"}
                readOnly
                disabled
              />
            </Form.Group>

            {/* Lease Period */}
            <Form.Group className="mb-3">
              <Form.Label>Lease Period (Months)</Form.Label>
              <Form.Control
                type="text"
                value={leasePeriod || "-"}
                readOnly
                disabled
              />
            </Form.Group>

            {/* Bedrooms */}
            <Form.Group className="mb-3" controlId="formBedrooms">
              <Form.Label>Number of Bedrooms</Form.Label>
              <Form.Select
                value={formData.bedroom}
                onChange={handleBedChange}
                required
              >
                <option value="">Select bedrooms</option>
                {bedOptions.map((option) => (
                  <option key={option.beds} value={option.beds}>
                    {option.beds} Bedrooms
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Please select number of bedrooms.
              </Form.Control.Feedback>
            </Form.Group>

            {/* Bathrooms */}
            <Form.Group className="mb-3" controlId="formBathrooms">
              <Form.Label>Number of Bathrooms</Form.Label>
              <Form.Select
                value={formData.bathroom}
                onChange={handleBathroomChange}
                required
              >
                <option value="">Select bathrooms</option>
                {bathroomOptions.map((option) => (
                  <option key={option.bathrooms} value={option.bathrooms}>
                    {option.bathrooms} Bathrooms
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* Multi Select Furniture */}
            {options?.length > 0 && (
              <Form.Group className="mb-3">
                <Form.Label>Select Furniture for this Package</Form.Label>
                <Select
                  isMulti
                  options={options}
                  onChange={handleChange}
                  value={options.filter((opt) =>
                    selectedFurnitureIds.includes(opt.value)
                  )}
                />
              </Form.Group>
            )}
            {housewareOptions?.length > 0 && (
              <Form.Group className="mb-3">
                <Form.Label>Select Houseware for this Package</Form.Label>
                <Select
                  isMulti
                  options={housewareOptions}
                  onChange={handleHousewareChange}
                  value={housewareOptions.filter((opt) =>
                    selectedHousewareIds.includes(opt.value)
                  )}
                />
              </Form.Group>
            )}
            {/* Buttons */}
            <div className="d-flex justify-content-end gap-3">
              <LoadrButton
                type="LoadrButton"
                variant="primary"
                isLoading={buttonLoader}
                style={{
                  width: "20%",
                  height: "50px",
                  backgroundColor: "#0474ba",
                }}
                onClick={handleSaveFurnitureSelection}
              >
                Save Package
              </LoadrButton>

              {/* <Button
                type="button"
                variant="primary"
                style={{
                
                  backgroundColor: "#0474ba",
                }}
                 isLoading={buttonLoader}
               onClick={handleSaveFurnitureSelection}
              >
                Save Package
              </Button> */}

              {packageId && (
                <Button
                  type="button"
                  variant="primary"
                  style={{
                    backgroundColor: "#0474ba",
                  }}
                  onClick={handleNewAddFurniture}
                >
                  Add New Furniture
                </Button>
              )}
              {packageId && (
                <Button
                  type="button"
                  variant="primary"
                  style={{
                    backgroundColor: "#0474ba",
                  }}
                  onClick={handleNewAddHouseware}
                >
                  Add New Houseware item
                </Button>
              )}
            </div>
          </form>
        </div>
      </div>
      <FurnitureTableList
        furnitureList={packageFurList}
        leasePeriod={leasePeriod}
        categoryId={categoryId}
        packageId={packageId}
        categoryName={categoryName}
        fetchPackageFurnithure={fetchPackageFurnithure}
      />
    </div>
  );
}

const FurnitureTableList = ({
  furnitureList,
  leasePeriod,
  categoryId,
  packageId,
  categoryName,
  fetchPackageFurnithure,
}) => {
  const { setFurEditData } = useContext(UserContext);
  const [deleteModal, setDeleteModal] = useState(false);
  const [delFurId, setDelFurId] = useState("");
  const [delLoader, setDelLoader] = useState(false);
  const { user } = useUserState();
  const navigate = useNavigate();

  // track quantities (current and original)
  const [quantities, setQuantities] = useState({});
  const [originalQuantities, setOriginalQuantities] = useState({});
  const [type, setType] = useState("");

  const handleQuantityChange = (id, change) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max(1, (prev[id] || 1) + change),
    }));
  };

  const handleUpdateQuantity = async (id) => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    const payload = {
      package_id: packageId,
      furniture_id: id,
      quantity: quantities[id],
    };
    try {
      const res = await axios.put(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/package-furniture/update-funiture-quantity`,
        payload,
        { headers: headersFormData }
      );

      if (res) {
        // Update original quantity for this item to match backend
        setOriginalQuantities((prev) => ({
          ...prev,
          [id]: quantities[id],
        }));
        fetchPackageFurnithure(packageId);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteFurniture = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      setDelLoader(true);
      try {
        const res = await axios.delete(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/furniture/delete/${delFurId}`,
          { headers: headersFormData }
        );
        if (res) {
          fetchPackageFurnithure(packageId);
          setDelLoader(false);
          setDeleteModal(false);
        }
      } catch (err) {
        console.log(err);
        setDelLoader(false);
      }
    }
  };

  // fetch current quantities from backend
  useEffect(() => {
    const fetchFurnitures = async () => {
      try {
        const res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/package-furniture/get-funiture-quantity`,
          {
            params: { package_id: packageId },
            headers: { Authorization: user?.token },
          }
        );
        const quantitiesData = {};
        res.data.data.forEach((item) => {
          quantitiesData[item.furniture_id] = item.quantity || 1;
        });
        setQuantities(quantitiesData);
        setOriginalQuantities(quantitiesData); // store original for comparison
      } catch (err) {
        console.error(err);
      }
    };

    if (user?.token) {
      fetchFurnitures();
    }
  }, [packageId, user?.token]);

  const normalizedFurnitureList = furnitureList.map((item) => ({
    ...item,
    type: item.type,
  }));

  const groupedFurniture = normalizedFurnitureList.reduce((acc, item) => {
    if (!acc[item.type || "Furniture"]) acc[item.type || "Furniture"] = [];
    acc[item.type || "Furniture"].push(item);
    return acc;
  }, {});

  return (
    <>
      {Object.entries(groupedFurniture).map(([type, items]) => {
        return (
          <div key={type} className="p-3">
            <h5 className="mb-3 ms-4 text-capitalize">{type}</h5>
            {items.length > 0 ? (
              <div className="table-responsive table_box_">
                <table className="table m-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Brand</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>{item.brand}</td>
                        <td>{item.price}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() => handleQuantityChange(item.id, -1)}
                            >
                              -
                            </Button>
                            <span>{quantities[item.id]}</span>
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() => handleQuantityChange(item.id, 1)}
                            >
                              +
                            </Button>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex gap-1">
                            {quantities[item.id] !==
                            originalQuantities[item.id] ? (
                              <Button
                                variant="outline-success"
                                size="sm"
                                title="Update quantity"
                                onClick={() => handleUpdateQuantity(item.id)}
                              >
                                Update
                              </Button>
                            ) : (
                              <Button
                                variant="outline-primary"
                                size="sm"
                                title="Edit package"
                                onClick={() => {
                                  setFurEditData(item);
                                  navigate(
                                    "/user_dash/furniture_company/add_new_furniture",
                                    {
                                      state: {
                                        categoryId,
                                        packageId,
                                        leasePeriod,
                                        categoryName,
                                      },
                                    }
                                  );
                                }}
                              >
                                Edit
                              </Button>
                            )}

                            <Button
                              variant="outline-danger"
                              size="sm"
                              title={`Delete ${type}`}
                              onClick={() => {
                                setDelFurId(item.id);
                                setDeleteModal(true);
                                setType(type);
                              }}
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="p-4">
                No {type} furniture for {leasePeriod} months package
              </p>
            )}
          </div>
        );
      })}

      <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete {type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this {type}!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            No
          </Button>
          <Button
            variant="primary"
            disabled={delLoader}
            onClick={() => handleDeleteFurniture()}
          >
            Yes {delLoader && <Spinner />}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
